import { render, staticRenderFns } from "./deduction.vue?vue&type=template&id=5c9a2e12&scoped=true"
import script from "./deduction.vue?vue&type=script&lang=js"
export * from "./deduction.vue?vue&type=script&lang=js"
import style0 from "./deduction.vue?vue&type=style&index=0&id=5c9a2e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a2e12",
  null
  
)

export default component.exports